var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.417 4.583v-.917a2.75 2.75 0 0 1 2.75-2.75h3.667a2.75 2.75 0 0 1 2.75 2.75v.917h3.666a.917.917 0 0 1 0 1.834h-.916v11.916a2.75 2.75 0 0 1-2.75 2.75H6.417a2.75 2.75 0 0 1-2.75-2.75V6.417H2.75a.917.917 0 0 1 0-1.834zm2.102-1.565a.92.92 0 0 1 .648-.268h3.667a.917.917 0 0 1 .916.917v.916h-5.5v-.917c0-.243.097-.476.269-.648M5.5 6.417v11.916a.916.916 0 0 0 .917.917h9.167a.917.917 0 0 0 .916-.917V6.417zm8.25 3.666v5.5a.917.917 0 0 1-1.833 0v-5.5a.917.917 0 1 1 1.833 0m-3.666 0a.917.917 0 1 0-1.834 0v5.5a.917.917 0 0 0 1.834 0z",
    clipRule: "evenodd"
  })));
};
export default SvgTrashIcon;